import { Box, Flex, HStack } from '@chakra-ui/react'
import React, { Fragment, useState } from 'react'
import { CollapsibleMenuProps } from './interface'
import MenuItem from '../MenuItem'
import { ChevronDownIcon, ChevronRightIcon } from '@chakra-ui/icons'

const CollapsibleMenu: React.FC<CollapsibleMenuProps> = ({ menu, level = 1 }) => {
  const [show, setShow] = useState(false)

  return (
    <Box py={2}>
      <Flex
        cursor="pointer"
        color="#fff"
        onClick={() => setShow(!show)}
        justifyContent="space-between"
        alignItems="center"
        pr="6px"
      >
        <HStack
          fontSize="14px"
          flex={1}
          pl={level > 1 ? `calc((${level} * 10px) + 22px)` : '10px'}
        >
          {menu.icon && <Box>{menu.icon}</Box>}
          <Box as="span" flex={1}>{menu.label}</Box>
        </HStack>
        <Box>{show ? <ChevronDownIcon /> : <ChevronRightIcon />}</Box>
      </Flex>
      {show &&
        menu.items?.map((elm) => {
          return (
            <Fragment key={elm.label}>
              {elm.items && elm.items.length >= 1 ? (
                <CollapsibleMenu menu={elm} level={level + 1} />
              ) : (
                <MenuItem menu={elm} level={level + 1} />
              )}
            </Fragment>
          )
        })}
    </Box>
  )
}

export default CollapsibleMenu
